import { z } from 'zod/v4';
import { ADDRESS_SCHEMA, IAddress } from '../user/address.interfaces';
import { FormControl } from '@angular/forms';

export interface IUserOnboardingForm {
  customerTypeSelection: FormControl<string>;
  salutation: FormControl<string>;
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  birthDate: FormControl<string>;
  phoneNumber: FormControl<string>;
  country: FormControl<string>;
  postCode: FormControl<string>;
  city: FormControl<string>;
  street: FormControl<string>;
  houseNumber: FormControl<string>;
  additional: FormControl<string>;
  confirmAddressIsAccurate: FormControl<boolean>;
  termsAccepted: FormControl<boolean>;
}

export interface IOnboardingStatus {
  completed: boolean;
}

export interface ICompleteOnboardingDto {
  firstName: string;
  lastName: string;
  birthDate: string;
  salutation: string;
  phoneNumber: string;
  address: IAddress;
  termsAccepted: true;
}

export interface OnboardingIdentity {
  subject: string;
  email: string;
}

export const ONBOARDING_STATUS_SCHEMA: z.ZodType<IOnboardingStatus> = z.object({
  completed: z.boolean(),
});

export const COMPLETE_ONBOARDING_SCHEMA: z.ZodType<ICompleteOnboardingDto> =
  z.object({
    firstName: z.string(),
    lastName: z.string(),
    birthDate: z.string(),
    salutation: z.string(),
    phoneNumber: z.string(),
    address: ADDRESS_SCHEMA,
    termsAccepted: z.literal(true),
  });
